import { Context, UuidIdGenerator } from '@prodcard/core'

export function createCtx(): Context {
  return {
    traceId: new UuidIdGenerator().generate(),
    langCode: 'ru',
  }
}
